import {
  FETCH_REFERRER_CONDITIONS,
  FETCH_REFERRER_CONDITIONS_LOADING,
  FETCH_REFERRER_CONDITIONS_ERROR,
  FETCH_REFERRER_CONDITION_BY_ID,
  FETCH_REFERRER_CONDITION_BY_ID_LOADING,
  FETCH_REFERRER_CONDITION_BY_ID_ERROR,
  SET_CONDITION_FILTERS,
  RESET_CONDITION_FILTERS,
  SET_CONDITION_SORT_PARAMS,
  SET_CONDITION_PAGINATION,
  RESET_CONDITION_PAGINATION
} from './ReferrerCondition.constants';
import { IReferrerConditionState, IAction } from './ReferrerCondition.types';

const defaultState: IReferrerConditionState = {
  totalConditionsCount: 0,
  filteredConditions: [],
  selectedCondition: null,
  isLoading: false,
  isLoadingMore: false,
  isFetchByIdLoading: false,
  errorMessage: null,
  fetchByIdErrorMessage: null,
  appliedFilters: {},
  sortParams: {
    sortBy: 'created_at',
    descendingOrder: true
  },
  pagination: {
    pageNumber: 1,
    limit: 20,
  },
  fetchedCount: 0,
  isNextPresent: false,
};

export default function referrerConditionReducer(state = defaultState, action: IAction) {
  switch (action.type) {
    case FETCH_REFERRER_CONDITIONS:
      return {
        ...state,
        totalConditionsCount: action.totalConditionsCount ?? state.totalConditionsCount,
        filteredConditions: action.isLoadMore ? [...state.filteredConditions, ...action.data] : action.data,
        errorMessage: null,
        fetchedCount: action.fetchedCount || 0,
        isNextPresent: action.isNextPresent ?? false,
        pagination: {
          ...state.pagination,
          ...(action.pagination || {}),
        }
      };

    case FETCH_REFERRER_CONDITIONS_LOADING:
      return {
        ...state,
        isLoading: action.isLoadMore ? false : action.data,
        isLoadingMore: action.isLoadMore ? action.data : false
      };

    case FETCH_REFERRER_CONDITIONS_ERROR:
      return { ...state, errorMessage: action.error };

    case FETCH_REFERRER_CONDITION_BY_ID:
      return { ...state, selectedCondition: action.data, fetchByIdErrorMessage: null };

    case FETCH_REFERRER_CONDITION_BY_ID_LOADING:
      return {
        ...state,
        isFetchByIdLoading: action.isLoading,
        selectedCondition: action.data || state.selectedCondition,
      };

    case FETCH_REFERRER_CONDITION_BY_ID_ERROR:
      return { ...state, fetchByIdErrorMessage: action.error };

    case SET_CONDITION_FILTERS:
      return { ...state, appliedFilters: action.filters };

    case RESET_CONDITION_FILTERS:
      return { ...state, appliedFilters: {} };

    case SET_CONDITION_SORT_PARAMS:
      return { ...state, sortParams: { ...state.sortParams, ...action.sortParams } };

    case SET_CONDITION_PAGINATION:
      return { ...state, pagination: { ...state.pagination, ...action.pagination } };

    case RESET_CONDITION_PAGINATION:
      return { ...state, pagination: defaultState.pagination };

    default:
      return state;
  }
}

